<template>
  <div>
    <div class="text-center mb-3">
      <h5>Статус:</h5>
      <div v-for="(phone, key) in phones" :key="key">
        {{ phone.name }}: {{ phone.body }}
      </div>
    </div>
    <div class="">
      <div class="border">
        <ACTIVITY v-model="dataLocal['activity_area_id']" :partner="partner" />
        <SELF_STATUS v-model="dataLocal['marital_status']" :partner="partner" />
        <div>
          <label>Профессия</label>
          <fg-input v-model="dataLocal['profession']"></fg-input>
        </div>

        <div>
          <label>Предпочтительный язык</label>
          <select class="form-control" v-model="preferred_language">
            <option
              v-for="(pl, key) in preferred_languages"
              :key="key"
              :value="pl.key"
            >
              {{ pl.title }}
            </option>
          </select>
        </div>
      </div>
      <button class="btn btn-success w-100 mt-2" @click="add">Добавить</button>
    </div>
  </div>
</template>
<script>
import ACTIVITY from "../REFERENCES/ACTIVITY.vue";
import SELF_STATUS from "../REFERENCES/SELF_STATUS.vue";
import { logger, errorNotify } from "../../../../plugins/functions";

export default {
  components: {
    ACTIVITY,
    SELF_STATUS,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  async created() {
    this.get();
  },
  data() {
    return {
      dataLocal: {},
      preferred_language: "uz",
      preferred_languages: [
        {
          title: "Узбекский язык",
          key: "uz",
        },
        {
          title: "Русский язык",
          key: "ru",
        },
      ],
    };
  },
  methods: {
    async add() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}clients/clients/${this.value.id}/questionnaire`,
        method: "POST",
        data: {
          ...this.dataLocal,
          preferred_language: this.preferred_language,
        },
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          this.$emit("update", true);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async get() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http({
        url: `${partner["endpoint_url"]}clients/clients/${this.value.id}/questionnaire`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${partner["api_secret_key"]}`,
        },
      })
        .then((response) => {
          if (response.data) {
            this.dataLocal = response.data;
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>